<template>
  <div class="pages">
    <div class="pagesContent">
      <!-- <top-nav :leftData='leftData' :activeNav='$route.params.pathId'></top-nav> -->
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{contentTitle}}</div>
          <div class="engName">{{englishName}}</div>
        </div>
        <div class="compContent">
          <div class="leftNav bl">
            <div :class="['item','fz22', activeName === item.name ? 'itemActive':'']" v-for="item in leftData.navs"
              :key="item.name" @click="changeTab(item)">
              {{item.text}}
            </div>
          </div>
          <infoBasic v-if="$route.params.pathId === 'infoBasic'"></infoBasic>
          <infoOther v-if="$route.params.pathId === 'infoOther'"></infoOther>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import topNav from '@/components/topNav'
  import infoBasic from '@/components/infoBasic'
  import infoOther from '@/components/infoOther'
  export default {
    name: 'info',
    components: {
      // topNav,
      infoBasic,
      infoOther
    },
    data() {
      return {
        leftData: {
          title: '信息披露',
          navs: [{
              name: 'infoBasic',
              text: '公司基本信息',
              fatherPath: 'info',
              english: 'ESSENTIAL INFORMATION'
            },
            {
              name: 'infoOther',
              text: '其他信息',
              fatherPath: 'info',
              english: 'OTHER INFORMATION'
            }
          ]
        },
        activeName: 'infoBasic'
      }
    },
    computed: {
      contentTitle() {
        return this.leftData.navs.find(item => item.name === this.$route.params.pathId).text
      },
      englishName() {
        return this.leftData.navs.find(item => item.name === this.$route.params.pathId).english
      }
    },
    created() {
      this.activeName = this.$route.params.pathId
    },
    mounted() {},
    methods: {
      changeTab(item) {
        if (this.activeName === item.name) return
        this.activeName = item.name
        this.$router.push({
          path: `/${item.fatherPath}/${item.name}`
        })
        this.$forceUpdate()
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .title{
    margin-top: 56px;
  }
  .compContent {
    display: flex;
    justify-content: space-between;
    .leftNav{
      width: 284px;
      .item{
        width: 284px;
        height: 94px;
        line-height: 94px;
        text-align: center;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
      }
      .itemActive{
        color: #2488CA;
      }
    }
  }
</style>